import PgxHeader from "./PgxHeader";
import PatientGenes from "./PatientGenes";
import React from "react";
import {useTranslation} from "react-i18next";

const NewPgxTest = ({
                      newPgx,
                      setNewPgx,
                      init = false,
                      handleSetPatGenes,
                      patientId,
                      handleSaveNewGeneTest,
                      handleCancel
                    }) => {
  const {t} = useTranslation();

  return (
    <div className="w3-container">
      <PgxHeader newPgx={ newPgx } setNewPgx={ setNewPgx } init={ init } createNewDialogOpened={ false }/>
      <PatientGenes patGenes={ newPgx?.genes } setPatGenes={ handleSetPatGenes } init={ init }
                    patientId={ patientId } showWarning ={ true } />
      <div className="w3-row w3-right w3-margin-bottom">
        <button className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right" onClick={ handleSaveNewGeneTest }>
          { t("save") }
        </button>
        {/*<button className="w3-btn w3-round-xlarge w3-theme-d5" onClick={handleCancel}>{t("cancel")}</button>*/}
      </div>
    </div>
  )
}

export default NewPgxTest;